import React from 'react'
import { EventInfo } from '../components';
import {FormGroup,FormControlLabel,Checkbox,IconButton,Box,TextField} from '@mui/material';
import moment from "moment";
import { FaFutbol,FaEye } from "react-icons/fa";

const DiffOddMobile = (props) => {
    const {showEventList} = props;

  return (
    <div>
         {
                showEventList && showEventList.map((v, i) => {
                  return (
                    <div className="mx-auto flex flex-col" key={i}>
                      <div className="mx-auto flex justify-between items-center w-[88%] text-sm text-background">
                        <div className="flex gap-1 items-center text-customFontGreen">
                          <FaFutbol />
                          <span>
                            {moment(v.event_time.value).format('DD-MM-YYYY hh:mm a')}
                          </span>
                        </div>
                        {/* <IconButton onClick={()=>handleClickOpen(v.event_Id_555)} size="small">
                        <FaEye/>
                        </IconButton> */}
                      </div>
                      <div className="flex flex-col justify-center gap-1 mx-2">
                        <EventInfo
                          homeTeamName={v.event_555_home}
                          awayTeamName={v.event_555_away}
                          homeOdd={v.home_odd_555}
                          awayOdd={v.away_odd_555}
                          goalOdd={v.goal_odd_555}
                          oddChange={v.is_body_diff || v.is_goal_diff ? true : false}
                          isMobile = {true}
                        />

                        <EventInfo
                          homeTeamName={v.event_909_home}
                          awayTeamName={v.event_909_away}
                          homeOdd={v.home_odd_909}
                          awayOdd={v.away_odd_909}
                          goalOdd={v.goal_odd_909}
                          oddChange={v.is_body_diff || v.is_goal_diff ? true : false}
                          isMobile = {true}
                        />
                      </div> 
                    </div>
                  )
                })
              }
    </div>
  )
}

export default DiffOddMobile;

